<header class="header"></header>

<div class="content">
  <app-identity-verification-stepper
    [currentStep]="3"
    [validSteps]="isIdentityComparisonSuccess ? 3 : 2"
    >
  </app-identity-verification-stepper>

  @if (!isIdentityComparisonSuccess) {
    <div class="image icon-scan"></div>
    <h1 class="title">Verification in progress...</h1>
  }

  @if (isIdentityComparisonSuccess) {
    <div class="check-image"></div>
    <h1 class="title">Verification Complete</h1>
  }
</div>
